<template>
  <div class="cpt-room-team-setting cpt-use-setting">
    <!-- <div class="room-team-tools-wrapper py-[4px] rounded-[5px] bg-fl-2 mb-[6px]">
      <div class="pointer-wrapper between not-cursor">
        <p>关联游戏</p>
        <el-select 
          class="team-tools-input prefix unset-color"
          :class="{'no-select': team_settings.appid == 0}"
          v-model="team_settings.appid"
          placeholder="不关联游戏"
          :key="roomThemeKey"
        >
          <div class="select-room-theme-icon" slot="prefix" v-if="teamSettingGame.pic_url">
            <ChatImg :lazy="false" :animation="false" :src="teamSettingGame.pic_url" :webp_quality="30" thumbnail="48x"/>
          </div>
          <el-option 
            v-for="item in teamGames"
            :key="item.appid"
            :value="item.appid"
            :label="item.name"
            style="width: 100%"
          >
          <div class="theme-icon">
            <ChatImg
              v-if="item.pic_url"
              :src="item.pic_url"
              :webp_quality="30"
              thumbnail="48x"
            />
            <span >{{item.name}}</span>
          </div>
          </el-option>
        </el-select>
      </div>
      
      <div class="pointer-wrapper between not-cursor" :class="{'disabled': team_settings.appid == 0}">
        <p>关联频道</p>
        <ChannelSelector 
          class="team-tools-input prefix unset-color"
          :value="team_settings.channel_id" 
          @change="handleTeamChannelChange"
          :disabled="team_settings.appid == 0"
          :need_request="false"
          :channels="textChannelList"
        />
      </div>

      <div
        class="pointer-wrapper between"
        :class="{'disabled': team_settings.appid == 0 || team_settings.channel_id == 0}"
        @click="editChanneTeamSetting('team_sync_room')"
      >
        <p>同步该游戏的组队工具贴到 关联频道</p>
        <el-switch
          @click.native="editChanneTeamSetting('team_sync_room')"
          v-model="team_settings.team_sync_room"
          :disabled="team_settings.appid == 0 || team_settings.channel_id == 0"
          style="height:16px;width:26px;"
        />
      </div>
      <div
        class="pointer-wrapper between"
        :class="{'disabled': team_settings.appid == 0 || team_settings.channel_id == 0}"
        @click="editChanneTeamSetting('room_sync_team')"
      >
        <p>同步关联频道内组队到 组队工具</p>
        <el-switch
          @click.native="editChanneTeamSetting('room_sync_team')"
          v-model="team_settings.room_sync_team"
          :disabled="team_settings.appid == 0 || team_settings.channel_id == 0"
          style="height:16px;width:26px;"
        />
      </div>
    </div> -->
    <div class="module-divider"></div>
    <div
      class="self-stretch text-tx-1 text-[14px] font-bold leading-[normal] my-[20px]"
    >
      组队设置
    </div>
    <div class="sub-title mt-[20px]">房间内组队</div>
    <div
      class="dropdown-container pointer"
      @click.stop="toggleShowDropDown"
    >
      <div class="text">选择一个分组以关联组队文字频道</div>
      <div class="icon">
        <i
          class="iconfont"
          :class="[showDropDown ? 'icon-arrow-up' : 'icon-arrow-down']"
        ></i>
      </div>
      <div
        class="dropdown-list"
        v-if="showDropDown"
      >
        <div class="inner-scroller">
          <div
            class="dropdown-item"
            :class="{ disabled: false }"
            @click="addItem(item)"
            v-for="item in channelGroupList"
            :key="item.channel_id"
          >
            <div class="dropdown-item-icon">
              <i class="iconfont icon-file"></i>
            </div>
            <div class="dropdown-item-info">
              <div
                class="dropdown-item-title"
                v-emoji-html="{
                  text: item.channel_name,
                  className: 'w-[14px]',
                }"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="team-channel-group rounded-[5px] bg-fl-2 mt-[10px]">
      <div class="flex-center group-head-wrapper">
        <div class="head-item w-[184px] pl-[12px]">分组</div>
        <div class="head-item w-[144px] px-[10px] text-center">关联频道</div>
        <div class="head-item w-[184px] px-[10px]">自定义标签</div>
      </div>
      <div
        class="group-body-wrapper"
        v-if="room_team_binds.length > 0"
      >
        <div
          class="group-body-item flex-center"
          v-for="item in room_team_binds"
          :key="item.id"
        >
          <div class="group-name flex-items-center">
            <i class="iconfont icon-file"></i>
            <span>{{ item.team_channel_name }}</span>
          </div>
          <div
            class="dropdown-container pointer"
            @click.stop="toggleBindDropDown($event, item)"
          >
            <i
              class="iconfont icon-topic-bold !text-[18px] !text-tx-4 mr-[6px]"
              v-if="item.text_chan_id"
            ></i>
            <div class="text">
              {{ item.text_chan_id ? item.text_channel_name : '添加关联频道' }}
            </div>
            <div class="icon">
              <i
                class="iconfont"
                :class="[
                  showBindDropDown === item.id
                    ? 'icon-arrow-up'
                    : 'icon-arrow-down',
                ]"
              ></i>
            </div>
          </div>
          <div class="tags flex-items-center">
            <div
              class="tag-item"
              v-for="(tagItem, tagIndex) in item?.tags?.slice(0, 1) || []"
              :key="tagItem + tagIndex"
            >
              {{ tagItem }}
            </div>
            <div
              class="tag-item more-btn"
              v-if="item.tags?.length && item.tags.length > 1"
            >
              +{{ item.tags.length - 1 }}
            </div>
            <div
              class="tag-item add-btn"
              @click.stop="handleAddTag(item)"
            >
              <i class="iconfont icon-add-bold"></i>
            </div>
          </div>
          <div
            class="action-icon flex-center"
            @click.stop="handleShowMoreMenu($event, item)"
          >
            <i class="iconfont icon-more"></i>
          </div>
        </div>
      </div>
      <div
        class="group-body-wrapper no-data flex-center"
        v-else
      >
        添加分组以设置组队关联频道及推荐关键词
      </div>
      <div
        class="dropdown-list"
        v-if="showBindDropDown"
        :style="bindDropPos"
      >
        <div class="inner-scroller">
          <div
            class="dropdown-item"
            :class="{
              disabled: item.disabled,
              'is-active':
                showBindDropDownItem.text_chan_id === item.channel_id,
            }"
            @click="setBindChannel(item)"
            v-for="item in textChannels"
            :key="item.channel_id"
          >
            <div
              class="dropdown-item-icon"
              v-if="item.icon_class"
            >
              <i
                class="iconfont"
                :class="item.icon_class"
              ></i>
            </div>
            <div class="dropdown-item-info">
              <div
                class="dropdown-item-title"
                v-emoji-html="{
                  text: item.channel_name,
                  className: 'w-[14px]',
                }"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 1.53.0版本开放组队大厅入口 -->
    <!-- <template v-if="global_team_setting.display">
      <div class="sub-title mt-[20px]">全局组队</div>
      <div class="global-team-setting module rounded-[5px] bg-fl-2 py-[4px]">
        <div
          class="flex-items-center justify-between h-[42px] p-[12px]"
          @click="editGlobalTeamSetting('open', !global_team_setting.open)"
        >
          <div
            class="name text-tx-2 text-[14px] leading-[18px] tracking-[0.14px]"
          >
            开启全局组队
          </div>
          <el-switch
            :value="global_team_setting.open"
            style="height: 16px; width: 26px"
          />
        </div>
        <div
          class="flex-items-center justify-between h-[42px] not-cursor room-team-tools-wrapper p-[12px]"
          :class="[!global_team_setting.open ? 'disabled' : '']"
        >
          <div
            class="name text-tx-2 text-[14px] leading-[18px] tracking-[0.14px]"
          >
            关联频道
          </div>
          <div class="w-[200px]">
            <ChannelSelector
              class="team-tools-input unset-color"
              :value="global_team_setting.bind_group"
              :channel_type="[CHANNEL_TYPES.group]"
              @change="editGlobalTeamSetting('bind_group', $event)"
              :need_request="true"
              noSelectDesc="无"
            />
          </div>
        </div>
      </div>
    </template> -->
  </div>
</template>

<script>
import ChannelSelector from '_com/busy/channelSelector';
import {
  getRoomTeamGames,
  bindTeam,
  editRoomDefaultSetting,
  getRoomTeamBind,
  setRoomTeamBind,
  deleteRoomTeamBind,
} from '_api/room/index';
import { editGlobalTeamSetting } from '_api/global-team';
import EventBus from '_lib/EventBus';
import { CHANNEL_TYPES } from '@/common/constants/channel';
import { mapGetters, mapMutations } from 'vuex';
import { deepCopy } from '_lib/utils/utils';
export default {
  components: {
    ChannelSelector,
  },
  props: {
    textChannelList: {
      type: Array,
      default: () => [],
    },
    roomInfo: {
      type: Object,
      default: () => ({}),
    },
    channels: {
      type: Array,
      default: () => [],
    },
    matchChannelList: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    teamSettingGame() {
      return (
        this.teamGames.find((item) => item.appid == this.team_settings.appid) ||
        {}
      );
    },
    teamSettingChannel() {
      return (
        this.textChannelList.find(
          (item) => item.channel_id == this.team_settings.channel_id
        ) || {}
      );
    },
    channelGroupList() {
      const groups = this.channels.filter(
        (item) => item.channel_type == CHANNEL_TYPES.group
      );
      return groups.filter(
        (item) =>
          !this.room_team_binds.find(
            (bind) => bind.team_chan_id == item.channel_id
          )
      );
    },
    groupChannelOptions() {
      const groups = this.channels.filter(
        (item) => item.channel_type == CHANNEL_TYPES.group
      );
      return [
        {
          channel_id: '0',
          channel_name: '不关联频道',
        },
        ...groups,
      ];
    },
    textChannels() {
      const list = this.textChannelList.filter((ch) => ch.channel_id != '0');
      return list.map((item) => ({
        ...item,
        disabled: !!this.room_team_binds.find(
          (bind) => bind.text_chan_id == item.channel_id
        ),
      }));
    },
  },
  watch: {
    team_settings: {
      handler(v) {
        this.handleBindTeam();
      },
      deep: true,
    },
  },
  data() {
    return {
      team_settings: {
        appid: 0,
        channel_id: '0',
        team_sync_room: true,
        room_sync_team: true,
        allow_global_team: true,
        global_sync_team: true,
      },
      global_team_setting: {
        display: false,
        open: false,
        bind_group: '',
      },
      teamGames: [],
      roomThemeKey: 0,
      showDropDown: false,
      room_team_binds: [],
      showBindDropDown: false,
      showBindDropDownItem: {},
      bindDropPos: {},

      CHANNEL_TYPES,
    };
  },
  created() {
    this.initData();
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    initData() {
      setTimeout(() => {
        this.roomThemeKey = Date.now();
      }, 500);
      Promise.all([this.getRoomTeamGames(), this.getRoomTeamBind()]).then(
        () => {
          this.is_binding_team = true;
          const room_bind_team = this.roomInfo.room_bind_team || {};
          this.team_settings.appid = room_bind_team.appid || 0;
          this.team_settings.channel_id = (room_bind_team.channel_id || 0) + '';
          if (room_bind_team.hasOwnProperty('team_sync_room')) {
            this.team_settings.team_sync_room = !!room_bind_team.team_sync_room;
          }
          if (room_bind_team.hasOwnProperty('room_sync_team')) {
            this.team_settings.room_sync_team = !!room_bind_team.room_sync_team;
          }
          setTimeout(() => {
            this.is_binding_team = false;
          }, 0);

          // 当前选择的游戏不再teamGames，的话，全部清空
          if (
            !this.teamGames.find(
              (item) => item.appid == this.team_settings.appid
            )
          ) {
            this.team_settings.appid = 0;
            this.team_settings.channel_id = '0';
            this.team_settings.team_sync_room = true;
            this.team_settings.room_sync_team = true;
          } else if (
            !this.textChannelList.find(
              (item) => item.channel_id == this.team_settings.channel_id
            )
          ) {
            this.team_settings.channel_id = '0';
            this.team_settings.team_sync_room = true;
            this.team_settings.room_sync_team = true;
          }
        }
      );
    },
    async getRoomTeamGames() {
      const { data } = await getRoomTeamGames({
        room_id: this.roomInfo.room_id,
      });
      if (data.status == 'ok') {
        this.teamGames = data.result.games || [];
      }
    },
    async getRoomTeamBind() {
      const { data } = await getRoomTeamBind({
        room_id: this.roomInfo.room_id,
      });
      if (data.status == 'ok') {
        const { room_team_binds = [], global_team_setting = {} } =
          data.result || {};
        this.SET_ROOM_TEAM_BINDS(room_team_binds);
        this.SET_GLOBAL_TEAM_SETTING(global_team_setting);
        this.room_team_binds = room_team_binds;
        this.global_team_setting = global_team_setting;
      }
    },
    addItem(item) {
      this.room_team_binds.push({
        id: Date.now(),
        is_temp: true,
        team_chan_id: item.channel_id,
        team_channel_name: item.channel_name,
        text_chan_id: '',
        tags: [],
        switch: true,
      });
      // this.setRoomTeamBind({
      //   team_chan_id: item.channel_id,
      //   text_chan_id: '',
      //   tags: [],
      //   switch: true
      // })
    },
    setBindChannel(item) {
      if (item.disabled) return;
      const setItem = {
        ...this.showBindDropDownItem,
        text_chan_id: item.channel_id,
      };
      this.setRoomTeamBind(setItem, () => {
        this.showBindDropDownItem = {};
        this.bindDropPos = {};
        this.showBindDropDown = false;
      });
    },
    setRoomTeamBind(item, cb) {
      if (this._setBindLock) {
        return;
      }
      this._setBindLock = true;
      setRoomTeamBind(
        {},
        {
          id: item.is_temp ? undefined : item.id,
          room_id: this.roomInfo.room_id,
          team_chan_id: item.team_chan_id,
          text_chan_id: item.text_chan_id,
          tags: item.tags,
          switch: item.switch,
        }
      )
        .then(({ data }) => {
          if (data.status == 'ok') {
            this.$toast.success('保存成功');
            const resultId = data.result.id;
            const index = this.room_team_binds.findIndex(
              (team) => team.id == item.id
            );
            if (item.is_temp) {
              this.$set(item, 'id', resultId);
            }
            if (index != -1) {
              const text_channel_name = item.text_chan_id
                ? this.textChannelList.find(
                    (ch) => ch.channel_id == item.text_chan_id
                  )?.channel_name
                : '添加关联频道';
              this.$set(this.room_team_binds, index, {
                ...this.room_team_binds[index],
                ...item,
                text_channel_name,
                is_temp: false,
              });
              this.SET_ROOM_TEAM_BINDS(this.room_team_binds);
            }
            cb && cb();
          }
        })
        .finally(() => {
          this._setBindLock = false;
        });
    },
    toggleShowDropDown() {
      this.showDropDown = !this.showDropDown;
    },
    toggleBindDropDown(event, item) {
      if (this.showBindDropDownItem.id === item.id) {
        this.showBindDropDownItem = {};
        this.bindDropPos = {};
        this.showBindDropDown = false;
        return;
      }
      this.showBindDropDownItem = item;
      this.showBindDropDown = item.id;

      if (this.showBindDropDown) {
        // 计算this.bindDropPos
        // 定位是在相对于team-channel-group的absolute
        this.$nextTick(() => {
          const clickedElement = event.currentTarget; // dropdown-container
          const teamChannelGroup = clickedElement.closest(
            '.team-channel-group'
          );

          if (clickedElement && teamChannelGroup) {
            // 获取 dropdown-container 相对于 team-channel-group 的位置
            const clickedRect = clickedElement.getBoundingClientRect();
            const groupRect = teamChannelGroup.getBoundingClientRect();

            // 计算相对位置
            const relativeLeft = clickedRect.left - groupRect.left;
            const relativeTop = clickedRect.bottom - groupRect.top;

            // 计算居中位置（dropdown-container 宽度的一半）
            const dropdownContainerWidth = clickedRect.width;
            const dropdownWidth = 212;
            const centeredLeft =
              relativeLeft + dropdownContainerWidth / 2 - dropdownWidth / 2;

            this.bindDropPos = {
              top: `${relativeTop + 4}px`,
              left: `${centeredLeft}px`,
              zIndex: 1000,
            };
          }
        });
      }
    },
    editChanneTeamSetting(key) {
      if (this.team_settings.appid == 0 || this.team_settings.channel_id == 0)
        return;
      this.team_settings[key] = !this.team_settings[key];
    },
    async editGlobalTeamSetting(key, value) {
      if (!this.global_team_setting.display) return;
      const base = {
        room_id: this.roomInfo.room_id,
      };
      const updateForm = {
        display: this.global_team_setting.display,
        bind_group: this.global_team_setting.bind_group,
        open: this.global_team_setting.open,
        [key]: value,
      };
      const body = {
        ...base,
        ...updateForm,
      };
      const {
        data: { status },
      } = await editGlobalTeamSetting({}, body);
      if (status === 'ok') {
        this.global_team_setting[key] = value;
        this.SET_GLOBAL_TEAM_SETTING({
          ...this.global_team_setting,
          ...updateForm,
        });
      }
    },
    handleTeamChannelChange(channel_id) {
      this.team_settings.channel_id = channel_id;
    },
    handleTeamGroupChannelChange(channel_id, item) {
      this.$set(item, 'channel_id', channel_id);
    },
    handleAddTag(item) {
      EventBus.$dynamic('EditRoomTeamTagsDialog', {
        initData: item,
        cb: (tags) => {
          this.$set(item, 'tags', tags);
          if (!item.is_temp) {
            this.setRoomTeamBind({
              ...item,
            });
          }
        },
      });
    },
    handleShowMoreMenu(event, item) {
      const groups = [
        {
          items: [
            {
              component: 'menu-button',
              data: {
                label: '删除该分组',
                type: 'warn',
              },
              onClick: () => {
                if (item.is_temp) {
                  this.room_team_binds = this.room_team_binds.filter(
                    (team) => team.id != item.id
                  );
                  this.SET_ROOM_TEAM_BINDS(this.room_team_binds);
                  return;
                }
                this.$query({
                  config: {
                    title: '确定删除该分组？',
                    confirm: {
                      text: '确定',
                      type: 'alert',
                    },
                    cancel: {
                      text: '取消',
                    },
                  },
                  confirmCB: () => {
                    deleteRoomTeamBind(
                      {},
                      {
                        id: item.id,
                        room_id: this.roomInfo.room_id,
                      }
                    ).then(({ data }) => {
                      if (data.status == 'ok') {
                        this.room_team_binds = this.room_team_binds.filter(
                          (team) => team.id != item.id
                        );
                        this.SET_ROOM_TEAM_BINDS(this.room_team_binds);
                        if (this.showBindDropDownItem.id == item.id) {
                          this.showBindDropDownItem = {};
                          this.bindDropPos = {};
                          this.showBindDropDown = false;
                        }
                      }
                    });
                  },
                });
              },
            },
          ],
        },
      ];
      this.$contextmenu({ event, groups });
    },
    handleBindTeam() {
      // if (this.team_settings.appid == 0 || this.team_settings.channel_id == 0) return
      if (this.team_settings.appid == 0) {
        this.team_settings.channel_id = '0';
      }
      if (this.is_binding_team) return;
      clearTimeout(this._bind_team_timer);
      this._bind_team_timer = setTimeout(() => {
        clearTimeout(this._bind_team_timer);
        if (this.is_binding_team) return;
        this.is_binding_team = true;
        bindTeam(
          {},
          {
            room_id: this.roomInfo.room_id + '',
            channel_id: this.team_settings.channel_id + '',
            appid: this.team_settings.appid,
            team_sync_room: this.team_settings.team_sync_room ? 1 : 0,
            room_sync_team: this.team_settings.room_sync_team ? 1 : 0,
          }
        )
          .then(({ data }) => {
            if (data.status == 'ok') {
              this.team_update_flag = true;
              if (this._isDestroyed) {
                this.updateView();
              }
            }
          })
          .finally(() => {
            this.is_binding_team = false;
          });
      }, 1000);
    },
    ...mapMutations(['SET_ROOM_TEAM_BINDS', 'SET_GLOBAL_TEAM_SETTING']),
  },
};
</script>

<style lang="scss">
.cpt-room-team-setting {
  margin-bottom: 20px;
  .dropdown-container {
    position: relative;
    display: flex;
    align-items: center;
    padding: 11px 12px;
    margin-bottom: 8px;
    align-self: stretch;
    border-radius: 5px;
    background: $d-op-s2;
    .text {
      flex: 1;
      overflow: hidden;
      color: $d-tx-4;
      text-overflow: ellipsis;

      font-size: 14px;
      line-height: 18px;
      letter-spacing: 0.14px;
    }
    .icon {
      & > .iconfont {
        color: $d-tx-3;
        font-size: 8px;
      }
    }
  }
  .dropdown-list {
    position: absolute;
    top: 42px;
    left: 0;
    right: 0;
    z-index: 1;
    display: flex;
    max-height: 310px;
    padding: 8px;
    flex-direction: column;
    align-items: flex-start;
    border-radius: 5px;
    background: $d-fl-pp;
    overflow-y: auto;
    overflow-x: hidden;

    /* 弹层阴影 */
    box-shadow: 0px 3px 15px 0px rgba(0, 0, 0, 0.35);
    .inner-scroller {
      width: 100%;
    }
    .dropdown-item {
      display: flex;
      width: 100%;
      height: 32px;
      padding: 6px 8px;
      padding-right: 30px;
      align-items: center;
      flex-shrink: 0;
      align-self: stretch;
      cursor: pointer;
      &.disabled {
        opacity: 0.4;
        cursor: not-allowed;
      }
      &.is-active {
        opacity: 1;
        .dropdown-item-title {
          color: $d-tx-1;
        }
        .dropdown-item-icon {
          .iconfont {
            color: $d-tx-1;
          }
        }
      }
      .dropdown-item-info {
        display: flex;
        flex: 1;
        align-items: center;
      }
      .dropdown-item-icon {
        margin-right: 6px;
        .iconfont {
          font-size: 16px;
          color: $d-tx-4;
        }
      }
      .dropdown-item-title {
        color: $d-tx-2;
        text-align: center;
        font-size: 14px;
        line-height: 18px;
        letter-spacing: 0.14px;
        max-width: 140px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .dropdown-item-desc {
        margin-left: 4px;
        color: $d-tx-4;
        font-size: 12px;
        line-height: 16px;
        letter-spacing: 0.12px;
        max-width: 120px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .dropdown-item-operation {
        margin-right: 0;
        display: flex;
        align-items: center;
        .dropdown-item-operation-item {
          display: flex;
          padding: 0px 27px;
          justify-content: center;
          align-items: center;
          gap: 4px;
          align-self: stretch;
          > .icon-toast-success {
            color: $d-bd-tx;
          }
        }
      }
    }
  }
  .team-channel-group {
    position: relative;
    .group-head-wrapper {
      border-bottom: 1px solid $d-ln-2;
      .head-item {
        height: 40px;
        line-height: 40px;
        color: $d-tx-3;
        font-size: 12px;
        line-height: 40px;
      }
    }
    .group-body-wrapper {
      max-height: 210px;
      overflow-y: scroll;
      padding-left: 8px;
      &.no-data {
        height: 42px;
        display: flex;
        border: 1px dashed $ct-bl-4;
        color: $d-tx-3;
        font-size: 13px;
        line-height: 18px;
        letter-spacing: 0.13px;
      }
      .group-body-item {
        height: 42px;
        border-radius: 4px;
        position: relative;
        padding: 0 4px;
        cursor: pointer;
        &:hover {
          background-color: $d-op-1;
        }
        &::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          height: 1px;
          background-color: $d-ln-2;
        }
        .group-name {
          width: 172px;
          padding-right: 10px;
          i.iconfont {
            font-size: 18px;
            color: $d-tx-2;
          }
          span {
            margin-left: 6px;
            color: $d-tx-2;
            font-size: 14px;
            line-height: 18px;
            letter-spacing: 0.14px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }

        .team-group-selector {
          // height: 32px;
          .el-select {
            .channel-info-wrapper.perfix {
              top: 8px;
            }
            .el-input .el-input__inner {
              background-color: $d-op-1 !important;
              height: 32px !important;
              max-width: 124px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }

        .tags {
          padding: 0 10px;
          width: 184px;
          gap: 6px;
          .tag-item {
            display: flex;
            align-items: center;
            justify-content: center;
            max-width: 76px;
            height: 30px;
            padding: 0 10px;
            color: $d-tx-3;
            text-align: center;
            font-size: 12px;
            line-height: 30px;
            border-radius: 4px;
            background-color: $d-op-1;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            &.add-btn {
              &:hover {
                background-color: $d-op-2;
              }
              .iconfont {
                font-size: 12px;
              }
            }
          }
        }
        .action-icon {
          position: absolute;
          top: 50%;
          right: 8px;
          transform: translateY(-50%);
          width: 22px;
          height: 22px;
          border-radius: 4px;
          &:hover {
            background-color: $d-op-2;
          }
          .iconfont {
            font-size: 12px;
            color: $d-tx-3;
          }
        }

        .dropdown-container {
          margin: 0 10px;
          height: 32px;
          align-self: auto;
          background: $d-op-1;
          border-radius: 4px;
          width: 124px;
          .text {
            color: $d-tx-2;
            font-size: 12px;
            line-height: 16px;
          }
        }
      }
    }
    .dropdown-list {
      z-index: 100;
      width: 212px;
    }
  }
  .default-channel-setting {
    .channel-info-wrapper.perfix {
      top: 8px;
    }
    .el-select-dropdown {
      max-width: 212px !important;
      min-width: 212px !important;
      .channel-info-wrapper {
        .channel-name {
          max-width: 130px !important;
        }
        .group-name {
          display: none;
        }
      }
    }
  }
}
</style>